import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./components/global/ErrorFallback";
import './locales/i18n';
import { SnackbarProvider } from 'notistack';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './auth/JwtContext';
import { ModalProvider } from './context/ModalContext';
import { ToastContainer } from 'react-toastify';
import Notification from './components/Notifications/Notification';
// import { GoogleOAuthProvider } from '@react-oauth/google';

// تسجيل الـ Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then((registration) => {
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}
if (navigator.setAppBadge) {
}
// navigator.setAppBadge(42);
// navigator.clearAppBadge();
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* <GoogleOAuthProvider clientId="913741101214-rgr8sl6ta7ltmai45r1ejk25khqtnmlm.apps.googleusercontent.com"> */}
    <ModalProvider>
      <AuthProvider>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => window.location.replace("/")}>
          <SnackbarProvider anchorOrigin={{ vertical: 'top', horizontal: 'right' }} >
            <App />
            <Notification />
          </SnackbarProvider>
        </ErrorBoundary>
      </AuthProvider>
    </ModalProvider>
    <ToastContainer style={{ zIndex: 100000000 }} />
    {/* </GoogleOAuthProvider> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
